import React from 'react';
import Button from '@mui/material/Button';
import Alert from 'ui/Alert/Alert';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

type Props = {
    onClick(): void;
    close(): void;
};

const StyWarning = styled(Alert, {
    name: 'StyWarning',
})({
    marginBottom: '1rem',
    alignItems: 'center',
});

const OrphanInscriptionsWarning = ({
    onClick,
    close,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <StyWarning
            action={
                <Button variant="outlined" onClick={onClick}>
                    {t('budgetProposal.orphanInscriptionWarningButton')}
                </Button>
            }
            severity="info"
            onClose={close}
        >
            {t('budgetProposal.orphanInscriptionWarning')}
        </StyWarning>
    );
};
export default OrphanInscriptionsWarning;
